<div class="mt-4 flex-grow-1" tabindex="0">
  <h6 [id]="idx+'-sysErrTxt'" style="color: #C25324;" class="text-center">
    <b>System Error:</b> Sorry, we encountered an issue on our side.
    <a role="link" [id]="idx+'-sysErrLink'" href="" style="color: #C25324;">Try refreshing the page.</a>
  </h6>
</div>
